import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useClientV2} from "../../../../utils/hooks";
import {CUSTOMER_PURCHASED_SUBSCRIPTIONS_RQ_KEY} from "../constants";
import {buildPaginationMeta} from "../shared/pagination-meta";
import {normalizeListCustomerSubscriptionsResponse} from "./normalize";
import type {ListCustomerPurchasedSubscriptionsResponse} from "./types";
import type {PaginationMeta} from "../../../../redux/service/i-service";

export type UseListCustomerPurchasedSubscriptionsResult = {
  data: {subscriptions: ListCustomerPurchasedSubscriptionsResponse["subscriptions"]};
  meta: PaginationMeta;
};

export const useListCustomerPurchasedSubscriptions = (
  page = 1,
  perPage = 5,
  options?: {enabled?: boolean}
) => {
  const client = useClientV2();
  const enabled = options?.enabled ?? true;

  return useQuery<
    UseListCustomerPurchasedSubscriptionsResult,
    AxiosError<{status: boolean; message: string}>
  >({
    enabled,
    queryKey: [CUSTOMER_PURCHASED_SUBSCRIPTIONS_RQ_KEY, page, perPage],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: String(page),
        perPage: String(perPage),
      });
      const raw = await client(`customer/subscriptions?${params}`);
      const normalized = normalizeListCustomerSubscriptionsResponse(raw);
      return {
        data: {subscriptions: normalized.subscriptions},
        meta: buildPaginationMeta(
          page,
          perPage,
          normalized.total,
          normalized.hasNextPage
        ),
      };
    },
    keepPreviousData: true,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
};
